module.exports = __webpack_public_path__ + "media/images/recipes/spareribs_vacuum_gekookt-26e84e3ead5431444ab73da45e0c4d0c.pdf";